import {useQuery} from '@tanstack/react-query'
import api from '../../../services/api/api'
import {QueryKeyEnum} from '../../../utilities/enums/QueryKeyEnum'

type Props = {
  enabled?: boolean
  filter: {
    clientIds?: Array<number>
    cameraIds?: Array<number>
    companyIds?: Array<number>
  }
  start: string
  end: string
}

export default function useDashboardGetAllCountingObjects({enabled, filter, start, end}: Props) {
  const query = useQuery({
    enabled,
    refetchOnWindowFocus: false,
    queryKey: [QueryKeyEnum.DASHBOARD_COUNTING_OBJECTS, filter, enabled, start, end],
    queryFn: async () => {
      const res = await api.reports.getDetectorCounts({filter, start, end})

      const result = res.data.objects.reduce<Record<string, {cameras: Array<string>; count: Array<number>; total: number}>>((acc, item) => {
        const {label, cameraName, count} = item
        const numericCount = Number(count)

        if (!acc[label])
          acc[label] = {
            cameras: [],
            count: [],
            total: 0,
          }

        acc[label].cameras.push(cameraName)
        acc[label].count.push(numericCount)
        acc[label].total += numericCount

        return acc
      }, {})

      return Object.entries(result)
    },
  })

  return query
}
